export default "/_next/static/data/trust-is-good-business-lottie.json-1b9eba8f20a390e84025db65d05c7a7d.json";